var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiscIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3823 0.191406H31.9751L46.6272 14.2428V41.2308C46.6272 44.5106 43.8295 47.1914 40.4129 47.1914H15.3823C11.9657 47.1914 9.16797 44.5106 9.16797 41.2308V6.15205C9.16797 2.87215 11.9657 0.191406 15.3823 0.191406Z",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9757 0.191406L46.6278 14.2428H33.5551C32.6869 14.2428 31.9756 13.5632 31.9756 12.7277V0.191406H31.9757Z",
    fill: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23398 20.2031H35.9798C36.7303 20.2031 37.3436 20.7914 37.3436 21.5113V33.3869C37.3436 34.1068 36.7303 34.6978 35.9798 34.6978H2.23398C1.48338 34.6978 0.870117 34.1068 0.870117 33.3869V21.5113C0.870117 20.7914 1.48338 20.2031 2.23398 20.2031Z",
    fill: "#9D9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscIcon);
export default __webpack_public_path__ + "static/media/MiscIcon.19339c0713242aac7696df60c2cbbd5f.svg";
export { ForwardRef as ReactComponent };